module.exports = __webpack_public_path__ + "static/img_download_googleplay-b203da1a53783d31d4f0e8cae36bfc48.png";